import { makeStyles } from '@material-ui/core';
import { tcsmColors } from '../../theme-constants/colors';



export const progressStyles = makeStyles((theme) => ({
    progressContainer: {
        borderBottom: `1px solid ${tcsmColors.greyFive}`,

        '& .MuiTabs-scrollButtons': {
            '& svg': {
                fill: tcsmColors.blue,
            },
        },
        '& .generic-stepper': {
            '&-tab': {
                '&-desktop': {
                    display: 'flex',
                    justifyContent: 'space-between',
                    paddingRight: theme.spacing(3),
                    paddingLeft: theme.spacing(3),
                    '&-inner': {
                        display: 'flex',
                    },
                },
                '&-item': {
                    paddingRight: theme.spacing(1.5),
                    paddingLeft: theme.spacing(1.5),
                    borderRight: `1px solid ${tcsmColors.greyFive}`,
                    '&:first-child': {
                        paddingLeft: 0,
                    },
                    '&-inner': {
                        paddingBottom: theme.spacing(1.5),
                        paddingTop: theme.spacing(1.5),
                        borderBottom: '4px solid transparent',
                        '&.active': {
                            borderColor: tcsmColors.blue,
                        },
                    },
                },
                '&-infobar': {
                    paddingTop: theme.spacing(.5),
                },
            },
            '&-bar': {
                '& .MuiTabs-scroller': {
                    paddingBottom: theme.spacing(1),
                    paddingTop: theme.spacing(1),
                },
            },
            '&-item': {
                marginRight: theme.spacing(1.5),
                minWidth: '18.75rem',
                display: 'flex',
                flex: '0 0 auto',
                [theme.breakpoints.down('md')]: {
                    minWidth: '10rem',

                },
                '&-icon': {
                    width: '2rem',
                    height: '2rem',
                    background: 'grey',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    backgroundColor: tcsmColors.greyFive,
                    borderRadius: '50%',
                    marginRight: theme.spacing(.5),
                    [theme.breakpoints.down('md')]: {
                        width: '1.25rem',
                        height: '1.25rem',
                    },
                    '& > svg': {
                        display: 'none',
                        fill: tcsmColors.white,
                        [theme.breakpoints.down('md')]: {
                            width: '1rem',
                            height: '1rem',

                        },
                    },

                    '&.pending': {
                        background: tcsmColors.blue,

                    },
                    '&.completed': {
                        background: tcsmColors.green,
                        '& > svg': {
                            display: 'block',
                        },
                    },
                },
            },
        },


    },



}));




